import icon from './images/customVideoPlayButton.png';
import { useState } from 'react';
import classnames from 'classnames';
import business1 from './images/1.png';
import business2 from './images/2.jpg';
import business3 from './images/3.png';
import contentPlanning1 from './images/contentPlanning1.png';
import contentPlanning2 from './images/contentPlanning2.png';


import styles from './index.module.css';

const cnmap = {
    video: '体育视频制作',
    content: '体育经纪、项目策划和执行',
}

const enmap = {
    video: 'Sports Video Production&Editing',
    content: 'Sports Content Planning',
}

const text = {
    cn: {
        title: '公司业务',
        tabs: ['video', 'content'],
        map: cnmap,
        video: [
            {
                title: '节目制作',
                description: '《致美之旅》《欧陆之星》为Prologue联合腾讯体育和壹球体育一起制作的展现顶尖体育赛事盛宴的节目，从橄榄球超级碗到NBA全明星赛再到世界足球俱乐部的顶峰之争欧洲冠军杯，都有制作拍摄团队ProLogue的专业助力。两档节目都收到了业界的极高评价。',
                img: business3,
            },
            {
                title: '纪录片',
                description: '《投中那颗LOGO SHOT》是NBA中国、腾讯体育合作出品的体育纪录片，讲述了包括曾凡博在内的7位球员在美打球和生活的动人故事，沈洋LISAHSU作为本纪录片的总导演以及项目发起人全权负责了整个纪录片的内容部分。',
                img: business1,
            },
            {
                title: '宣传片',
                description: '2023年布鲁克林篮网中国新年赛，我们用影像和照片呈现出了篮网队整个中国春节特别赛的筹备和宏大场面，是球队和赞助商在活动和赛事中的完美结合和对于双方品牌价值的共同立意的展现。',
                img: business2,
            },
        ],
        content: [
            {
                title: '内容策划与服务',
                description: '为NBA中国策划了2023-2024新赛季里和NBA退役球星在中国各大直播平台的连线活动',
                img: contentPlanning1,
            },
            {
                title: '经纪与联络服务',
                description: '1.比尔和快手的账号入驻、短视频内容和直播内容的合作\n\n2.尼克杨和RIO鸡尾酒的广告拍摄合作',
                img: contentPlanning2,
            },
        ]
    },
    en: {
        title: 'Area of Service',
        tabs: ['video', 'content'],
        map: enmap,
        video: [
            {
                title: 'Programming',
                description: '“Experience The Power of Legend”is a road trip show that starts in Phoenix and ends in Salt Lake City. The trip includes the Super Bowl and the All-Star Game, as well as the sightseeing experience of featured cities and scenic spots.ProLogue, as the content production team for the show, was responsible for all the content production work and received high praise from the industry.',
                img: business3,
            },
            {
                title: 'Documentary',
                description: '“Logo shot” went behind the scenes to document the stories of seven young Chinese athletes living their basketball dreams in the U.S., including Fanbo Zeng, Michael Wang, Fuqu Wang,Xinyi Li, Hao Hu, Yutong Zhang Since premiering, the docuseries have generated thoughtful discussions and positive reviews within China’s sports industry.',
                img: business1,
            },
            {
                title: 'Promotional Video',
                description: "The 2023 Brooklyn Nets Chinese New Year Game. With video, photos and all the production parts that ProLogue took charge, presents the Nets' preparations and grand scenes for the entire Chinese New Year special game. It is the perfect combination of the team and sponsors in the events and games, and the shared commitment to the brand value of both sides.",
                img: business2,
            },
        ],
        content: [
            {
                title: 'Content Planning Service',
                description: 'Make planning and copywriting for the content requirements of various platforms and partners, help them to obtain relevant knowledge and help in sports professional field more quickly and efficiently, and realize the copywriting and planning content.',
                img: contentPlanning1,
            },
            {
                title: 'Brokerage and execution service',
                description: 'In cooperation with Priority, one of the most well-known talent agencies in the United States, and Kuaishou, the most well-known short video interactive platform in China, we helped Bradley Beal, a player signed by Priority, to join Kuaishou, and helped Beal interact and communicate with fans on this platform',
                img: contentPlanning2,
            },
        ]
    },
}

const CorporateBusiness = (props) => {
    const { 
        // currentIndex, 
        l = 'cn' } = props;
    const [checked, setChecked] = useState(text[l]['tabs'][0]);
    const [isHoverIndex, setIsHoverIndex] = useState(-1);
    return (
        <div className={styles['page']}>
            <div
                className={styles['page-content']}
                style={{
                    // top: currentIndex === 2 ? 0 : 300,
                    // opacity: currentIndex === 2 ? 1 : 0,
                }}
            >
                <div className={styles['content']}>
                    <div className={styles['left']}>
                        <div className={styles['left-content']}>
                            <div className={styles['title']}>{text[l]['title']}</div>
                            <div className={styles['line']}>&nbsp;</div>
                            <div style={{ height: 40 }}>&nbsp;</div>
                            {text[l]['tabs'].map(item => (
                                <div
                                    className={styles['check-item']}
                                >
                                    {checked === item && (
                                        <img
                                            src={icon}
                                            className={styles['icon']}
                                            alt=''
                                        />
                                    )}
                                    <span
                                        className={styles['check-label']}
                                        onClick={() => {
                                            setChecked(item);
                                        }}
                                        style={{
                                            color: checked === item ? '#01D598' : '',
                                            fontWeight: checked === item ? 'bold' : '',
                                            fontSize: checked === item ? 24 : 16
                                        }}
                                    >
                                        {text[l]['map'][item]}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles['right']}>
                        <div className={styles['right-content']}>
                            <div
                                className={classnames(styles['cards-box'], {
                                    [styles['card-box-show']]: checked === 'video'
                                })}
                            >
                                {text[l][checked].map((item, index) => (
                                    <div
                                        key={item.title}
                                        className={classnames(styles['card-video'])}
                                        onMouseEnter={() => {
                                            setIsHoverIndex(index);
                                        }}
                                        onMouseLeave={() => {
                                            setIsHoverIndex(-1);
                                        }}
                                    >
                                        <img src={item.img} className={styles['img']} alt=''/>
                                        <div
                                            className={classnames(styles['card-description'], {
                                                [styles['card-description-show']]: isHoverIndex === index,
                                            })}
                                        >
                                            <div
                                                className={styles['card-des-title']}
                                                style={{
                                                    fontSize: l === 'cn' ? 24 : 20,
                                                    fontWeight: (l === 'en' && isHoverIndex === index) ? 'bold' : undefined,
                                                    letterSpacing: -1
                                                }}
                                            >{item.title}</div>
                                            <div 
                                            className={styles['card-description-des']}
                                            style={{
                                                lineHeight: l === 'cn' ? '28px' : '16px'
                                            }}
                                            >
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                className={classnames(styles['cards-box1'], {
                                    [styles['card-box1-show']]: checked === 'content'
                                })}
                            >
                                {text[l][checked].map((item, index) => (
                                    <div
                                        key={item.title}
                                        className={classnames(styles['card-content'])}
                                        onMouseEnter={() => {
                                            setIsHoverIndex(index);
                                        }}
                                        onMouseLeave={() => {
                                            setIsHoverIndex(-1);
                                        }}
                                    >
                                        <img src={item.img} className={styles['img']} alt=''/>
                                        <div
                                            className={classnames(styles['card-description'], {
                                                [styles['card-description-show']]: isHoverIndex === index,
                                            })}
                                        >
                                            <div
                                                className={styles['card-des-title']}
                                                style={{
                                                    fontSize: l === 'cn' ? 24 : 18,
                                                    fontWeight: (l === 'en' && isHoverIndex === index) ? 'bold' : undefined,
                                                    
                                                }}
                                            >{item.title}</div>
                                            <div 
                                            className={styles['card-description-des']}
                                            style={{
                                                lineHeight: l === 'cn' ? '28px' : '20px',
                                                whiteSpace:'pre-wrap',
                                            }}
                                            >
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CorporateBusiness;